import axios from "axios";
import store from "@/store";
import { ElNotification } from "element-plus";
import router from "@/router";

const signOut = [401];

// 一些请求的基本配置
axios.defaults.baseURL = process.env.VUE_APP_URL;
axios.defaults.timeout = 300000;
/*跨域请求是否提供凭据信息(cookie、HTTP认证及客户端SSL证明等)，也可以简单的理解为，当前请求为跨域类型时是否在请求中协带cookie。
当配置了xhr.withCredentials = true时，必须在后端增加 response 头信息Access-Control-Allow-Origin，且必须指定域名，而不能指定为**/
// axios.defaults.withCredentials = false;

/*const { CancelToken, isCancel } = axios // CancelToken能为一次请求‘打标识’
cancelToken 取消请求
if (isCancel(error)) {
    //如果进入判断，证明：是用户取消了请求
    console.log('用户取消了请求，原因是', error.message);
} else {
    console.log('失败了', error);
}*/

// 60000
// 300000
axios.interceptors.request.use(
  (config) => {
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json;charset=utf-8;";
    }
    const token = store.getters.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // 处理请求错误
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (res) => {
    if (res.data.code === 200) {
      // 获取token
      if (res.headers.token) {
        store.commit("SET_TOKEN", res.headers.token);
      }

      return res.data;
    } else if (signOut.includes(res.data.code)) {
      ElNotification.error({
        title: res.data.msg,
        customClass: "ApiMessage",
      });
      router.replace({
          name: "login"
      })
    }else if (res.config.responseType === "blob") {
      return res;
    }else {
      ElNotification.error({
        title: res.data.msg,
        customClass: "ApiMessage",
      });
      return false;
    }
  },
  (error) => {
    if (error.code === "ECONNABORTED") {
      console.log("连接超时，网络不加");
      ElNotification.error({
        title: "连接超时，网络不加",
        customClass: "ApiMessage",
      });
    } else if (error.response.status === 400) {
      ElNotification.error({
        title: error.response.data.message,
        customClass: "ApiMessage",
      });
    } else if (error.response.status === 401) {
      router.replace({
        name: "login",
      });
      ElNotification.error({
        title: error.response.data.message,
        customClass: "ApiMessage",
      });
    } else if (error.response.status === 403) {
      router.replace({
        name: "login",
      });
      ElNotification.error({
        title: error.response.data.message,
        customClass: "ApiMessage",
      });
    } else if (error.response.status === 405) {
      ElNotification.error({
        title: error.response.data.message,
        customClass: "ApiMessage",
      });
    } else if (error.response.status === 500) {
      ElNotification.error({
        title: error.response.data.message,
        customClass: "ApiMessage",
      });
    }
    return Promise.reject(error);
  }
);

export function File(url, data) {
  return new Promise((resolve, reject) => {
    axios({
      url,
      method: "post",
      data,
      responseType: "blob",
      onDownloadProgress(progress) {
        // console.log(progress);
      },
    })
      .then((res) => {
          const fileName = res.headers["content-disposition"].split("''")[1];
          // let url = window.URL.createObjectURL(new Blob([res]));
          let url = window.URL.createObjectURL(res.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", decodeURIComponent(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function get(url, params, falg) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        falg ? url + "/" + params : url,
        falg
          ? {}
          : {
              params: params,
            }
      )
      .then((res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        });
  });
}

export function post(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then((res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        });
  });
}

export function upload(url, data, config) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config)
            .then((res) => {
                    resolve(res);
                },
                (err) => {
                    reject(err);
                });
    });
}

export function put(url, data) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function patch(url, data) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function del(url, params, falg) {
  return new Promise((resolve, reject) => {
    axios
      .delete(
        falg ? url + "/" + params : url,
        falg
          ? {}
          : {
              params: params,
            }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
